import { render, staticRenderFns } from "./CompanySwitchConfirmDialog.vue?vue&type=template&id=46c5304b&scoped=true"
import script from "./CompanySwitchConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanySwitchConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanySwitchConfirmDialog.vue?vue&type=style&index=0&id=46c5304b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c5304b",
  null
  
)

export default component.exports